type HostEnv = 'production' | 'stage' | 'development' | 'sandbox' | 'isocomp';

const isDeveloper = computed(() => {
  const { relevantCookies } = useWwwStorage();
  const devCookie = relevantCookies.value.find(
    (cookie) => cookie.name === 'x-www-is-internal-developer'
  );
  return devCookie?.value;
});

const getHostEnv = (): HostEnv => {
  const url = useRequestURL().host;

  if (url.includes('localhost')) {
    return 'development';
  }

  if (url.includes('stage')) {
    return 'stage';
  }

  if (url.includes('sandbox')) {
    return 'sandbox';
  }

  if (url.includes('isocomp')) {
    return 'isocomp';
  }

  return 'production';
};

const useEnvContext = () => {
  const hostEnv = getHostEnv();

  return readonly({
    isDev: computed(() => hostEnv === 'development'),
    isStage: computed(() => hostEnv === 'stage'),
    isProd: computed(() => hostEnv === 'production'),
    isSandbox: computed(() => hostEnv === 'sandbox'),
    isIsocomp: computed(() => hostEnv === 'isocomp'),
    isDeveloper,
  });
};

export default useEnvContext;
